<template>
  <slot :recurringPrice="recurringPrice" :discountPrice="discountPrice">
    <div :class="discountPrice && 'line-through text-xs text-gray-400'">
      kr. {{ formatPrice(recurringPrice) }} /mnd.
    </div>
    <div v-if="discountPrice">
      kr. {{ formatPrice(discountPrice) }} /mnd. første år
    </div>
  </slot>
</template>

<script lang="ts" setup>
import { formatPrice } from "../../helpers/priceHelpers";
import { useMicrosoft365CatalogStore } from "~/stores/catalog/microsoft-365-catalog";

const props = defineProps<{
  subscriptionId: number;
}>();

const microsoft365Catalog = useMicrosoft365CatalogStore();

const subscription = computed(() =>
  microsoft365Catalog.getSubscriptionById(props.subscriptionId)
);

if (!subscription.value) {
  throw new Error("Subscription not found");
}

const recurringPrice = computed(() => {
  return subscription.value?.priceRecurring?.unitPriceWithDiscount ?? "?";
});

const discountPrice = computed(() => {
  if (typeof recurringPrice.value !== "number") {
    return null;
  }

  const startupPrice = subscription.value?.priceStartup?.unitPriceWithDiscount;

  if (!startupPrice) {
    return null;
  }

  if (startupPrice >= recurringPrice.value) {
    return null;
  }

  return subscription.value?.priceStartup?.unitPriceWithDiscount;
});
</script>

<style></style>
